import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { authProtectedRoutes, publicRoutes } from './allRoutes';
import Layout from 'Layout';
import AuthProtected from './AuthProtected';
import Pages404 from '../pages/AuthenticationInner/Pages404';

const RouteIndex = () => {
  return (
    <React.Fragment>
      <Routes>
        {authProtectedRoutes.map((route: any, idx: number) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <AuthProtected>
                <Layout>
                  <route.component />
                </Layout>
              </AuthProtected>
            }
          />
        ))}
        {publicRoutes.map((route: any, idx: number) => (
          <Route
            path={route.path}
            key={idx}
            element={
              <Layout>
                <route.component />
              </Layout>
            } />
        ))}
        {/* Ruta para 404 */}
        <Route path="/not-found" element={
          <Layout>
            <Pages404 />
          </Layout>
        } />
        {/* Redirección para cualquier ruta no encontrada */}
        <Route path="*" element={<Navigate to="/not-found" replace />} />
      </Routes>
    </React.Fragment>
  );
};

export default RouteIndex;